export interface StripeProduct {
  id: string;
  priceId: string;
  name: string;
  description: string;
  price: number;
  currency: string;
  mode: 'subscription' | 'payment';
  interval?: 'month' | 'year';
}

export const STRIPE_PRODUCTS: StripeProduct[] = [
  {
    id: 'monthly',
    priceId: import.meta.env.VITE_STRIPE_MONTHLY_PRICE_ID || 'price_1TBd9AHTa4glvwaRTFPgTGTb',
    name: 'Monthly',
    description: 'Unlimited countdowns, custom photos, advanced reminders, calendar view & more',
    price: 2.99,
    currency: 'usd',
    mode: 'subscription',
    interval: 'month'
  },
  {
    id: 'yearly',
    priceId: import.meta.env.VITE_STRIPE_YEARLY_PRICE_ID || 'price_1TBd9tHTa4glvwaRutEzz7Xx',
    name: 'Yearly',
    description: 'Unlimited countdowns, custom photos, advanced reminders, calendar view & more',
    price: 19.99,
    currency: 'usd',
    mode: 'subscription',
    interval: 'year'
  }
];

export const getProductByPriceId = (priceId: string): StripeProduct | undefined => {
  return STRIPE_PRODUCTS.find(product => product.priceId === priceId);
};

export const getProductByInterval = (interval: 'month' | 'year'): StripeProduct | undefined => {
  return STRIPE_PRODUCTS.find(product => product.interval === interval);
};